export class Authority {
  id?: number;
  mode?: boolean;
  type: number|null;
  type1Select1?: number|null; 	// 自然人著作 法人著作 選擇
  type1Input1?: string;	  // 自然人著作 法人著作 輸入
  type1Select2?: number|null;	  // 長期著作保護類型 短期著作 選擇
  type1Date?: number;	    // 公開發表日期

  constructor() {
    this.type = null;
    this.type1Select1 = null;
    this.type1Select2 = null;
  }
}

export const TYPE1_OPTIONS = [
  {label: '公眾領域標章(PDM)', value: 0, url: 'http://creativecommons.tw/pdm', image: './assets/image/publicdomain.large.png'},
  {label: '公眾領域貢獻宣告(CC0)', value: 1, url: 'http://creativecommons.tw/cc0', image: './assets/image/CCzero.large.png'},
  {label: '政府資料開放授權條款-第1版(OGDL 1.0)', value: 2, url: 'https://data.gov.tw/license', image: ''},
  {label: '創用CC姓名標示 3.0 台灣及其後版本(CC BY 3.0 TW +)', value: 3, url: 'https://creativecommons.org/licenses/by/3.0/tw/legalcode', image: 'https://i.creativecommons.org/l/by/3.0/tw/88x31.png'},
  {label: '創用CC姓名標示-相同方式分享 3.0 台灣及其後版本(CC BY-SA 3.0 TW +)', value: 4, url: 'https://creativecommons.org/licenses/by-sa/3.0/tw/legalcode', image: 'https://i.creativecommons.org/l/by-sa/3.0/tw/88x31.png'},
  {label: '創用CC姓名標示-非商業性 3.0 台灣及其後版本(CC BY-NC 3.0 TW +)', value: 5, url: 'https://creativecommons.org/licenses/by-nc/3.0/tw/legalcode', image: 'https://i.creativecommons.org/l/by-nc/3.0/tw/88x31.png'},
  {label: '創用CC姓名標示-非商業性-相同方式分享 3.0 台灣及其後版本(CC BY-NC-SA 3.0 TW +)', value: 6, url: 'https://creativecommons.org/licenses/by-nc-sa/3.0/tw/legalcode', image: 'https://i.creativecommons.org/l/by-nc-sa/3.0/tw/88x31.png'},
  {label: '創用CC姓名標示-禁止改作 3.0 台灣及其後版本(CC BY-ND 3.0 TW +)', value: 7, url: 'https://creativecommons.org/licenses/by-nd/3.0/tw/legalcode', image: 'https://i.creativecommons.org/l/by-nd/3.0/tw/88x31.png'},
  {label: '創用CC姓名標示-非商業性-禁止改作 3.0 台灣及其後版本(CC BY-NC-ND 3.0 TW +)', value: 8, url: 'https://creativecommons.org/licenses/by-nc-nd/3.0/tw/legalcode', image: 'https://i.creativecommons.org/l/by-nc-nd/3.0/tw/88x31.png'},
  {label: '台中自由文化授權條款 1.0(相容於CC BY 4.0)', value: 9, url: 'http://digitalculture.tw/license/TCFCL', image: ''},
  {label: '台中開放文化授權條款 1.0(相容於CC BY-SA 4.0)', value: 10, url: 'http://digitalculture.tw/license/TCOCL', image: ''},
  {label: '受著作權法保護-僅限於本平台有限度公開瀏覽', value: 11, url: '', image: ''},
  {label: '資料尚待處理，僅做暫存', value: 12, url: '', image: ''}
];

export const TYPE2_OPTIONS1 = [
  {label: '自然人著作', value: 0},
  {label: '法人著作', value: 1}
];

export const TYPE2_OPTIONS2 = [
  {label: '長期著作保護類型', value: 0},
  {label: '短期著作保護類型', value: 1}
];
